import { Link } from 'react-router-dom';

function ManCaveBash() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center py-12 px-4">
      <div className="max-w-3xl w-full bg-white rounded-xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">Man Cave Bashes</h1>
        
        <div className="flex justify-center mb-6">
          <img src="/mcb_favicon.png" alt="Man Cave Bash Icon" className="w-16 h-16" />
        </div>

        <p className="text-gray-600 mb-4">
          A <span className="font-semibold">Man Cave Bash</span> is a unique gathering designed for men to come together in fellowship, fun, and meaningful connection. Hosted by 414 Ministry, these events are all about creating a space where guys can relax, share stories, and build stronger bonds in a laid-back environment.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mb-3">What to Expect</h2>
        <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
          <li><span className="font-medium">Fellowship:</span> Engage in conversations that matter—whether it’s about faith, life, or just sharing a laugh.</li>
          <li><span className="font-medium">Activities:</span> Enjoy games, food, and activities tailored for men, like axe-throwing, BBQ, or watching a game.</li>
          <li><span className="font-medium">Community:</span> Connect with other men from the 414 Ministry community and beyond.</li>
          <li><span className="font-medium">Relaxation:</span> Kick back in a “man cave” setting—think comfy seating, good music, and a chill vibe.</li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-900 mb-3">Why Attend?</h2>
        <p className="text-gray-600 mb-4">
          Man Cave Bashes are a great way to take a break from the daily grind, strengthen friendships, and grow in faith together. Whether you’re new to the ministry or a long-time member, you’ll find a welcoming group ready to hang out and have a good time.
        </p>

        <div className="text-center mt-6">
          <Link to="/" className="inline-block bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-blue-700">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ManCaveBash;